import { generatePath } from 'react-router';

import { URL_PARAM_APPLICATION_ID } from '@funnels/constants';

import { getBrandSpecificDashboardBaseURL, getBrandSpecificHomepageURL } from './brand';

const baseName = `/v2/dashboard/application/:${URL_PARAM_APPLICATION_ID}/`;

/**
 * Return url of HomePage for pre-auth and Dashboard for other part of the app
 *
 * @param applicationId - Application Id.
 * @returns The home page or dashboard URL.
 *
 * @example
 * For Lendi funnel-one:
 * ```
 * /
 * ```
 * @example
 * For Lendi funnel-two:
 * ```
 * /v2/dashboard/application/${applicantionId}/
 * ```
 */
export function getDashboardUrl(applicationId?: string) {
  /**
   * applicationId will ne undefined in pre-auth (funnel one) but will have value for other part of th app
   * This funtion will return HomepageURL for funnel one but DashboardUrl for other part of the app
   */
  if (!applicationId) {
    return getBrandSpecificHomepageURL();
  }
  const domainSpeceficUrl = `${getBrandSpecificDashboardBaseURL()}${baseName}`;

  return generatePath(domainSpeceficUrl, { [URL_PARAM_APPLICATION_ID]: applicationId });
}
